import { IAppState } from 'app/redux/App/reducer'
import { store } from 'app/redux/App/store'
import { IReducerAction } from 'app/redux/FunctionalReducer'
import * as Redux from 'redux'
import * as ReduxThunk from 'redux-thunk'

type ActionPromiseCallback<A> = (getState: () => IAppState) => Promise<A>

interface ISharedVariables {
  accessToken: string
}

const shared: ISharedVariables = {
  accessToken: undefined
}

/**
 * ActionCreator class has
 * If that sounds Greek, See Redux.md at app/redux/Redux.md for a redux refresher.
 *
 */
export abstract class ActionCreator<IState, IAction extends IReducerAction = IReducerAction> {

  constructor(private actionStore = store) { }

  /**
   * Get shared variable between all ActionCreators
   * @param key
   */
  public getSharedVar<K extends keyof ISharedVariables>(key: K): ISharedVariables[K] {
    return shared[key]
  }

  /**
   * Set shared variable between all ActionCreators
   * @param key
   */
  protected setSharedVar<K extends keyof ISharedVariables>(key: K, value: ISharedVariables[K]) {
    shared[key] = value
  }

  /**
   * Synchronous dispatch an action to the reducer method
   * @param action
   */
  protected dispatch(action: IAction) {
    return this.actionStore.dispatch<IAction>(action)
  }

  /**
   * Asynchronous dispatch an action to the reducer method
   * Example:
   * this.dispatchAsync((getState) => {
   *   return new Promise((resolve, reject) => {
   *     resolve(action)
   *   })
   * })
   * @param asyncAction ReduxThunk action
   */
  protected dispatchAsync(actionPromiseCallback: ActionPromiseCallback<IAction>) {
    return this.actionStore.dispatch<Promise<IAction>, void>((dispatch, getState) => {
      return actionPromiseCallback(getState)
        .then((action) => dispatch(action))
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/ActionCreator.ts